/**
 * Strip characters that operating systems / filesystems reject from a
 * download filename. Keeps Turkish letters and other Unicode word
 * characters intact (so a "Üretim Raporu" dashboard becomes a sensible
 * "Üretim_Raporu.xlsx") while cutting the Windows-reserved set
 * (`<>:"/\|?*`) and runs of whitespace.
 *
 * Also collapses runs of underscores so a name like "a__b" doesn't
 * produce "a___b" after substitution. Empty / whitespace-only input
 * returns an empty string — callers fall back to a default base.
 */
export function sanitizeFileName(name: string): string {
  if (!name) return '';
  // Reserved on Windows + spaces. The dash inside the class is escaped
  // so eslint doesn't read `* -` as a range (which would silently sweep
  // in control bytes via the no-control-regex rule).
  const reserved = /[<>:"/\\|?*\- ]/g;
  return (
    name
      .trim()
      .replace(reserved, '_')
      .replace(/_{2,}/g, '_')
      // Strip leading / trailing junk (underscores produced from spaces,
      // dots that confuse Windows Explorer) so "foo. " doesn't survive
      // as "foo._".
      .replace(/^[._]+|[._]+$/g, '')
  );
}
